module.exports = __webpack_public_path__ + "img/time.d5557f56.png";